/*jQuery(document).ready(function($) {
	
	var new_post_links = $('#wp-admin-bar-my-sites-list').find('.ab-item:contains("New Post")');
	
	$.each(new_post_links, function(idx, val) {
		$(this).parent().remove();
	});
	
	var manage_comments_links = $('#wp-admin-bar-my-sites-list').find('.ab-item:contains("Manage Comments")');
	
	$.each(manage_comments_links, function(idx, val) {
		$(this).parent().remove();
	});
	
});*/

// Note: Rewrote this to remove jQuery dependency.
// This is now being compiled into the Homepage plugin
// frontend scripts and to help with page load speed,
// that script is all Vanilla JS so we can (hopefully)
// remove jQuery from the page. (RB - 2/5/25)

document.addEventListener('DOMContentLoaded', function () {
	const mySitesList = document.getElementById('wp-admin-bar-my-sites-list');
	if (!mySitesList) return;

	// Function to remove parent <li> of matching links
	function removeLinksContainingText(text) {
		const links = mySitesList.querySelectorAll('.ab-item');
		links.forEach(link => {
			if (link.textContent.trim() === text) {
				const parentLi = link.closest('li');
				if (parentLi) {
					parentLi.remove();
				}
			}
		});
	}

	removeLinksContainingText('New Post');
	removeLinksContainingText('Manage Comments');
});